<template>
  <div class="withdrawal-history-box">
    <top-header :text="$t('guild_withdrawal_records')" :color="'#000'"></top-header>

    <!-- 可滚动容器 -->
    <div class="list-scroll-container hide-scrollbar">
      <!-- 使用 van-list 实现上拉加载 -->
      <van-list
      v-if="list.length > 0"
        v-model="loadingMore"
        :finished="noMore"
        :finished-text="$t('guild_apply_time')"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="list-item" v-for="(item, index) in list" :key="index">
          <span
            :class="{
              status1: item.status === 0,
              status2: item.status === 1,
              status3: item.status === 2,
              status4: item.status === 3
            }"
          >
            {{ getStatusText(item.status) }}
          </span>
          <div>
            <p class="amount">{{ formatAmount(item.coinNum) }}</p>
            <div class="back-limit-box">
              <p>{{ $t('guild_submit_application') }}: {{ getWithdrawTypeText(item.withdrawType) }}</p>
              <p v-if="item.refunded">{{ $t('guild_cancel') }}</p>
            </div>
            <p>{{ $t('guild_confirm_submit_application') }}: {{ formatDate(item.createTime) }}</p>
            <p v-if="item.status !== 0">{{ $t('guild_freeze_notice') }}: {{ formatDate(item.updateTime) }}</p>
          </div>
          <div  v-if="item.reason && item.status !== 3" class="refuse-box">
            <div class="refuse-header">{{ $t('guild_communicate_with_leader') }}</div>
            <div class="refuse-content">{{ item.reason}}</div>
          </div>
        </div>
      </van-list>
      <div v-else class="no-data-box">
        <p></p>
      </div>
    </div>

    <div class="service-box">
      <p>{{ $t('guild_process_time') }}</p>
      <p @click="goPublish">{{ $t('guild_rejection_reason') }}</p>
    </div>

    <!-- 全屏 loading -->
    <div class="loading-box" v-if="loading">
      <van-loading type="spinner" vertical />
    </div>
  </div>
</template>

<script>
import axios from "axios";
// 按需引入 Vant 组件（局部使用）
import VanList from 'vant/lib/list';
import VanLoading from 'vant/lib/loading';

// 引入样式
import 'vant/lib/list/style';
import 'vant/lib/loading/style';

import topHeader from "@/components/withdrawal/top-header.vue";

export default {
  name: "withdrawalHistory",
  components: {
    topHeader,
    VanList,
    VanLoading // van-list 依赖 Loading，必须注册
  },
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,     // 全屏加载
      loadingMore: false, // 底部加载更多
      noMore: false,      // 是否无更多数据
      guildId:'',       //公会id
      appealToPlatformUrl:''
    };
  },
  created(){
    this.guildId = this.$route.query.guildId;
    this.guildUid = this.$route.query.guildUid;
    this.appealToPlatformUrl = this.$route.query.toUrl || '';
  },
  mounted() {
    this.getUserInfo();
    // 初始加载第一页
    this.onLoad();
  },
  methods: {
    goPublish(){
      // 新增type=3  跳转到问题反馈页面后选择提现类型问题反馈 20260302
        window.open(this.appealToPlatformUrl + '?isShowNav=0&langType=' + this.lang + '&userId=' + this.uid + '&type=4')
    },
    // 获取用户信息（保持不变）
    getUserInfo() {
      var ids = navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|BlackBerry|Windows Phone)/
      );
      if (ids) {
        ids = ids[0];
      } else {
        ids = "Unknown Device";
      }
      let data = JSON.parse(localStorage.getItem("data"));
      this.token = data.token;
      this.uid = data.uid || data.userId;
      this.lang = data.lang || navigator.language;
      this.deviceId = data.deviceId || ids;
      let langs = this.lang.substring(0, 2);
      if (langs == "zh") {
        if (this.lang == "zh-TW" || this.lang == "zh-HK") {
          this.$i18n.locale = "tc";
        } else {
          this.$i18n.locale = "zh";
        }
      } else if (langs == "en") {
        this.$i18n.locale = "en";
      } else if (langs == "ar") {
        this.$i18n.locale = "ar";
      } else if (langs == "tr") {
        this.$i18n.locale = "tr";
      } else if (langs == "es") {
        this.$i18n.locale = "es";
      } else if (langs == "pt") {
        this.$i18n.locale = "pt";
      } else if (langs == "fr") {
        this.$i18n.locale = "fr";
      } else if (langs == "id") {
        this.$i18n.locale = "id";
      } else if (langs == "ms") {
        this.$i18n.locale = "ms";
      } else {
        this.$i18n.locale = "en";
      }
      document.title = this.$t("withdrawalLogin.title");
      document.querySelector("html").setAttribute("lang", this.$i18n.locale);
    },

    // 格式化金额（示例：5000 → 5,000）
    formatAmount(amount) {
      if (!amount) return '0';
      return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    // 格式化时间（假设后端返回 ISO 或时间戳）
    formatDate(timestamp) {
      if (!timestamp) return '--';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}/${month}/${day} ${hours}:${minutes}`;
    },
    // 状态文本映射
    getStatusText(status) {
      if (status === 0) return this.$t('guild_confirm');
      if (status === 1) return this.$t('guild_withdrawal_method');
      if (status === 2) return this.$t('guild_leader_withdraw');
      if (status === 3) return this.$t('guild_status_timeout_rejected');
      return '未知';
    },
    // 提现方式映射
    getWithdrawTypeText(type) {
      const typeMap = {
        1: this.$t('guild_self_withdraw'),
        2: this.$t('guild_transfer_to_leader'),
        3: this.$t('guild_salary_to_reseller'),
        4: this.$t('guild_convert_to_diamond'),
        5: this.$t('guild_platform_settlement'),
        //新增Reseller类型 20260302
        6: 'RESELLER'
      };
      return typeMap[type] || '未知';
    },
    // 加载数据（被 van-list 调用）
    onLoad() {
      if (this.noMore) return;
      if (this.page === 1) {
        this.loading = true; // 首次加载显示全屏 loading
      } else {
        this.loadingMore = true; // 后续加载显示底部 loading
      }
      
      axios.get(this.$serviceIp + `api/trade/guild/withdraw/record?page=${this.page}&pageSize=${this.pageSize}&guildId=${this.guildId}&applyUid=${this.uid}&token=${this.token}&uid=${this.uid}`,{
          headers: {
              'version': '3.0',
              'deviceId': this.deviceId,
                'lang': this.lang,
            }
      })
      .then(({data}) => {
        this.loading = false;
        this.loadingMore = false;
        if (data.code === 200) {
          const newData = data.data.list || [];
          if (this.page === 1) {
            this.list = newData;
          } else {
            this.list.push(...newData);
          }
          // 如果返回的数据少于 pageSize，说明没有更多数据了
          if (newData.length < this.pageSize) {
            this.noMore = true;
          } else {
            this.page += 1;
          }
        } else {
          this.$message?.error(data.msg || '加载失败');
          this.loadingMore = false;
        }
      })
      .catch((err) => {
        this.loading = false;
        this.loadingMore = false;
        this.$message?.error(err.message || '网络错误');
      });
    }
  }
};
</script>

<style scoped>
body {
  background-color: #f5f6f8;
  font-family: "Mada";
}
html[lang="ar"] .withdrawal-history-box {
  direction: rtl;
}
html[lang="ar"] .list-item span {
  left: 0;
  right: auto;
}
html[lang="ar"] .amount::before {
  margin-right: 0;
  margin-left: 4px;
}
html[lang="ar"] .refuse-header::before {
  margin-right: 0;
  margin-left: 4px;
}
.withdrawal-history-box{
    background-color: #F5F6F8;
}
/* 滚动容器 */
.list-scroll-container {
  padding: 0 25px;
  margin-top: 16px;
  height: calc(100vh - 130px - 120px);
  overflow-y: auto;
}

/* 单个列表项（原 li） */
.list-item {
  min-height: 152px;
  padding: 16px 24px;
  border-radius: 24px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  margin-bottom: 20px;
}

/* 原 .list-tips 已由 van-list 的 finished-text 替代 */

.list-item p {
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  color: #89848d;
}

.list-item span {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
  font-weight: 400;
  height: 48px;
  line-height: 48px;
  text-align: center;
  padding: 0 24px;
  border-radius: 0 20px 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.list-item span::before {
  content: "";
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.status1 {
  color: #e78300;
  background-color: #ffe6d2;
}
.status1::before {
  background: url("../../assets/h5/status1.png") no-repeat;
  background-size: 100% 100%;
}
.status2 {
  color: #0060e7;
  background-color: #d2ebff;
}
.status2::before {
  background: url("../../assets/h5/status2.png") no-repeat;
  background-size: 100% 100%;
}
.status3 {
  color: #e54444;
  background-color: #ffe2e2;
}
.status3::before {
  background: url("../../assets/h5/status3.png") no-repeat;
  background-size: 100% 100%;
}
.status4 {
  color: #89848D;
  background-color: #E9E9E9;
}
.status4::before {
  background: url("../../assets/h5/status4.png") no-repeat;
  background-size: 100% 100%;
}

.list-item .amount {
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 30px;
  font-weight: 600;
  color: #262427;
  margin-bottom: 10px;
}
.amount::before {
  content: "";
  width: 34px;
  height: 34px;
  background: url("../../assets/h5/icon$.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 4px;
}

.back-limit-box {
  display: flex;
  justify-content: space-between;
}
.back-limit-box p:nth-of-type(2) {
  font-size: 20px;
  color: #afa9b4;
  margin-top: -5px;
}

.refuse-box {
  min-height: 60px;
  border-radius: 16px;
  background-color: #fff4f4;
  padding: 20px 24px;
  margin-top: 10px;
}
.refuse-header {
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  color: #ff4365;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.refuse-header::before {
  content: "";
  width: 30px;
  height: 30px;
  background: url("../../assets/h5/elert.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
}
.refuse-content {
  font-size: 22px;
  font-weight: 500;
  line-height: 30px;
  color: #262427;
  padding-left: 36px;
}

.service-box {
  width: 100%;
  height: 120px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  padding-top: 24px;
  box-sizing: border-box;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);
}
.service-box p {
  font-size: 24px;
  line-height: 30px;
  font-weight: 500;
  text-align: center;
  color: #89848d;
  margin-bottom: 8px;
}
.service-box p:nth-of-type(2) {
  color: #4d70ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.service-box p:nth-of-type(2)::before {
  content: "";
  width: 32px;
  height: 32px;
  background: url("../../assets/h5/service.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 5px;
}

.loading-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}
.no-data-box{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.no-data-box p{
    width: 240px;
    height: 240px;
    background: url('../../assets/withdrawal/null.png') no-repeat;
    background-size: 100% 100%;
}
/* 隐藏滚动条 */
.hide-scrollbar {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* WebKit */
}
</style>